import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  hero: {
    objectFit: "cover",
    width: "100%",
    height: 200,
  },
  wrapHeader: {
    textAlign: "center",
    padding: "30px 0",
    paddingBottom: 10,
  },
  wrapCard: {
    padding: 20,
  },
  wrapGrid: {
    // textAlign:"center"
    width: "50%",
  },
  wrapList: {
    marginTop: "100px",
  },
  liquid: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: 500,
  },
  wrapKredit: {
    paddingBottom: "100px",
  },
  liquidTitle: {
    fontWeight: "bold",
    color: theme.palette.textColor.primeTextColor,
    fontSize: 17.5,
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidPrimaryTitle: {
    fontSize: 14,
    fontWeight: "bold",
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidSecondList: {
    maxWidth: "100px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  secondItem: {
    marginTop: "20px",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 20px",
  },
}));

export default useStyles;
